import { Component, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { TranslateService } from '@ngx-translate/core';

interface VideoItem {
  id: string;
  title: string;
  alt: string;
  caption: string;
}

@Component({
  selector: 'app-help-information', 
  templateUrl: './help-information.component.html',
  styleUrl: './help-information.component.scss',
  standalone: false
})
export class HelpInformationComponent {   
  private readonly sanitizer = inject(DomSanitizer);
  private readonly translate = inject(TranslateService);
  videos: VideoItem[] = [
    { id: '4ahcvYP1b9o', 
      title: this.translate.instant('PRIVATE.HELP-INFORMATION.VIDEO1-TITLE'), 
      alt: this.translate.instant('PRIVATE.HELP-INFORMATION.VIDEO1-ALT'),
      caption: this.translate.instant('PRIVATE.HELP-INFORMATION.VIDEO1-CAPTION')},
    { id: 'dADyVcaJxAg', 
      title: this.translate.instant('PRIVATE.HELP-INFORMATION.VIDEO2-TITLE'),
      alt: this.translate.instant('PRIVATE.HELP-INFORMATION.VIDEO2-ALT'),
      caption: this.translate.instant('PRIVATE.HELP-INFORMATION.VIDEO2-CAPTION')},
    { id: 'F6m7xGvo0x0', 
      title: this.translate.instant('PRIVATE.HELP-INFORMATION.VIDEO3-TITLE'), 
      alt: this.translate.instant('PRIVATE.HELP-INFORMATION.VIDEO3-ALT'),
      caption: this.translate.instant('PRIVATE.HELP-INFORMATION.VIDEO3-CAPTION')},
    { id: 'EtkqeppbPFU', 
      title: this.translate.instant('PRIVATE.HELP-INFORMATION.VIDEO4-TITLE'),
      alt: this.translate.instant('PRIVATE.HELP-INFORMATION.VIDEO4-ALT'),
      caption: this.translate.instant('PRIVATE.HELP-INFORMATION.VIDEO4-CAPTION')},
    { id: 'LC03IWj0ZNE', 
      title: this.translate.instant('PRIVATE.HELP-INFORMATION.VIDEO5-TITLE'), 
      alt: this.translate.instant('PRIVATE.HELP-INFORMATION.VIDEO5-ALT'),
      caption: this.translate.instant('PRIVATE.HELP-INFORMATION.VIDEO5-CAPTION')},
    { id: 'EnQNulUZzFE',              
      title: this.translate.instant('PRIVATE.HELP-INFORMATION.VIDEO6-TITLE'), 
      alt: this.translate.instant('PRIVATE.HELP-INFORMATION.VIDEO6-ALT'),
      caption: this.translate.instant('PRIVATE.HELP-INFORMATION.VIDEO6-CAPTION')},
    { id: 'm7J0rXMy4u4', 
      title: this.translate.instant('PRIVATE.HELP-INFORMATION.VIDEO7-TITLE'),
      alt: this.translate.instant('PRIVATE.HELP-INFORMATION.VIDEO7-ALT'),
      caption: this.translate.instant('PRIVATE.HELP-INFORMATION.VIDEO7-CAPTION')},
   
  ];

  isModalOpen = false;
  currentVideoUrl: SafeResourceUrl | null = null;
  faXmark = faXmark;

 

  openVideo(id: string): void {
    this.currentVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      `https://www.youtube.com/embed/${id}?autoplay=1`
    );
    this.isModalOpen = true;
  }

  closeModal(): void {
    this.isModalOpen = false;
    this.currentVideoUrl = null; 
  }
}
